import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import AdminPageLayout from "../../../components/FullPageLayout/AdminPageLayout";
import Table from "../../../components/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { Add } from "@mui/icons-material";
import { makeGetEntities } from "../../../redux/selectors/selectors";
import { fetchIntegrations } from "../../../redux/actions/repositoryActions";
import IntegrationModal from "./IntegrationModal";
import TokenModal from "./TokenModal";

const selector = makeGetEntities();
const columns = [
  {
    title: "Name",
    field: "name",
    options: {
      sorting: true
    }
  }
];

const IntegrationSettings = () => {
  const dispatch = useDispatch();
  const [integration, showToken] = useState(null);
  const [addIntegration, setAddIntegration] = useState(null);

  useEffect(() => {
    dispatch(fetchIntegrations());
  }, []);

  const { integrations } = useSelector(({ repositoryState }) => ({
    integrations: selector(repositoryState, {
      type: "integrations"
    })
  }));

  // TODO: Move copy to translations
  return (
    <AdminPageLayout
      title={"Integrations"}
      headerActions={
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={() => setAddIntegration(true)}
        >
          {"Add Integration"}
        </Button>
      }
    >
      <TokenModal
        onClose={() => showToken(null)}
        open={!!integration}
        integration={integration}
      />
      <IntegrationModal
        onClose={() => setAddIntegration(false)}
        open={addIntegration}
      />
      <Box display="flex" flexDirection="column" my={4}>
        <Table
          columns={columns}
          onRowClick={(e, rowData) => showToken(rowData)}
          data={integrations}
          filtering={false}
        />
      </Box>
    </AdminPageLayout>
  );
};

export default IntegrationSettings;
